// strategic-layers.js

import React from 'react';
import './strategic-layers.css';

// --- Updated Content for Leading Fintech Parent Company ---
const strategicPillars = [
  {
    id: 1,
    title: "Vertical Integration Power",
    icon: (
      <svg width="32" height="32" viewBox="0 0 24 24" fill="#E94E4E" xmlns="http://www.w3.org/2000/svg">
        <path d="M10 4H14V10H19V14H14V20H10V14H5V10H10V4Z"/>
      </svg>
    ),
    details: "A unified platform architecture integrating diverse lending products and business units under one robust technology core."
  },
  {
    id: 2,
    title: "AI-Driven Risk Modeling",
    icon: (
      <svg width="32" height="32" viewBox="0 0 24 24" fill="#E94E4E" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 2C13.1 2 14 2.9 14 4V8H18C19.1 8 20 8.9 20 10V14C20 15.1 19.1 16 18 16H14V20C14 21.1 13.1 22 12 22C10.9 22 10 21.1 10 20V16H6C4.9 16 4 15.1 4 14V10C4 8.9 4.9 8 6 8H10V4C10 2.9 10.9 2 12 2Z"/>
      </svg>
    ),
    details: "Proprietary ML models delivering real-time, superior risk assessment and predictive analytics across market segments."
  },
  {
    id: 3,
    title: "Scalability & Elasticity",
    icon: (
      <svg width="32" height="32" viewBox="0 0 24 24" fill="#E94E4E" xmlns="http://www.w3.org/2000/svg">
        <path d="M4 4H20V6H4V4ZM4 10H16V12H4V10ZM4 16H12V18H4V16Z"/>
      </svg>
    ),
    details: "Engineered for hyper-growth, capable of scaling transaction volume and customer base across multiple geographies instantly."
  },
  {
    id: 4,
    title: "Customer-Centric Velocity",
    icon: (
      <svg width="32" height="32" viewBox="0 0 24 24" fill="#E94E4E" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 2C17.52 2 22 6.48 22 12H20C20 7.58 16.42 4 12 4V2ZM12 22C6.48 22 2 17.52 2 12H4C4 16.42 7.58 20 12 20V22ZM12 6C15.31 6 18 8.69 18 12C18 15.31 15.31 18 12 18C8.69 18 6 15.31 6 12C6 8.69 8.69 6 12 6Z"/>
      </svg>
    ),
    details: "Optimized processes and swift technology delivery ensuring industry-leading speed in loan sanction and disbursement."
  },
];

const LayerPillar = ({ data, alignment }) => (
  <div
    className={`layer-pillar ${alignment}`}
    data-aos={alignment === 'left' ? "fade-right" : "fade-left"}
    data-aos-delay={data.id * 150}
  >
    <div className="pillar-header">
      <span className="icon-badge">{data.icon}</span>
      <h3 className="pillar-title">{data.title}</h3>
    </div>
    <p className="pillar-details">{data.details}</p>
  </div>
);

const StrategicLayersSection = () => {
  return (
    <section className="strategic-layers-container">
      <div className="layered-background">
        <div className="cut-shape-one"></div>
        <div className="cut-shape-two"></div>
      </div>

       <h2 className="display-4 strategic-title mb-2 text-dark">
                    Strategic Core: <span className="strategic-secondary-info"> Our Momentum Engine</span>
                </h2>

      <div className="pillars-layout">
        {strategicPillars.map((data, index) => (
          <LayerPillar
            key={data.id}
            data={data}
            alignment={index % 2 === 0 ? 'left' : 'right'}
          />
        ))}
      </div>
    </section>
  );
};

export default StrategicLayersSection;
